const getters = {
  role: (state) => state.permission.role,
  menus: (state) => state.permission.menus,
  allMenusList: (state) => state.permission.allMenusList,
  allMenusTree: (state) => state.permission.allMenusTree,
  activeMenu: (state) => state.permission.activeMenu,
  activeMenuTree: (state) => state.permission.activeMenuTree,
  activeMenuChildren: (state) => state.permission.activeMenuChildren,
  site: (state) => state.permission.siteInfo,
  // 当前查看项目信息
  currentProject: (state) => state.permission.currentProject,
  currentBids: (state) => state.permission.currentBids,
  currentNotice: (state) => state.permission.currentNotice,
  noticeHtml: (state) => state.permission.noticeHtml,
  //站点下的机构单位
  enterprises: (state) => state.permission.enterprises,
  //新闻资讯
  channel_xwzx: (state) => state.permission.channel_xwzx,
  //关于我们
  channel_gywm: (state) => state.permission.channel_gywm,
  //资料下载
  channel_zlxz: (state) => state.permission.channel_zlxz,
  //常见问题
  channel_cjwt: (state) => state.permission.channel_cjwt,
  //合作机构
  channel_hzjg: (state) => state.permission.channel_hzjg,
  //友情链接
  channel_yqlj: (state) => state.permission.channel_yqlj,
  //业务指南
  channel_ywzn: (state) => state.permission.channel_ywzn,
  //联系平台
  channel_lxwm: (state) => state.permission.channel_lxwm,
  //操作指引
  channel_czzy: (state) => state.permission.channel_czzy,
  // 数据统计
  channel_sjtj: (state) => state.permission.channel_sjtj,
}

export default getters
